module.exports = __webpack_public_path__ + "static/media/amelie.a1a13fbb.jpg";